import Routes from "@/components/Routes";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { UserProvider } from "@/contexts";
import { BrowserRouter } from "react-router-dom";
import { MapProvider } from "@/contexts/MapContext";
import { useState } from 'react';
import { createTrpcClient, trpc } from "@/services/trpc";

// const queryClient = new QueryClient();

function App() {
  const [queryClient] = useState(() => new QueryClient());
  const [trpcClient] = useState(createTrpcClient());

  return (
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <UserProvider>
            <MapProvider>
              <Routes />
            </MapProvider>
          </UserProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </trpc.Provider>
  );
}

export default App;
